<template>
    <div class="question" :class="{'new':newClass}">
        <h2 class="title" v-html="questionLabel"></h2>
        <p v-if="question.text !== ''" v-html="questionText"></p>
        <div v-if="question.type !== 'none'">
            <div v-if="question.type === 'text'">
                <input type="text" v-model="value" :readonly="locked" placeholder="Réponse" @focus="$emit('textfocus')" @blur="$emit('textblur')">
            </div>
            <div v-if="question.type === 'textarea'">
                <textarea type="text" v-model="value" :readonly="locked" placeholder="Réponse" @focus="$emit('textfocus')" @blur="$emit('textblur')"></textarea>
            </div>
            <div v-if="question.type === 'select'" class="select">
                <select v-model="value" :disabled="locked">
                    <option v-for="(content,k) in question.content" :value="content.value">{{content.value}}</option>
                </select>
            </div>
            <div v-if="question.type === 'checkbox'" class="checkbox-content">
                <div v-for="(content,k) in question.content" class="checkbox mb">
                    <label>
                        <input type="checkbox" :checked="isChecked(k)" :disabled="locked" @change="onChange(k,$event)">
                        {{content.value}}
                    </label>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import tools from '../../config.ts';

    export default {
        name: "Question",
        components: {},
        props: {
            question: {},
            response: {},
            locked: false,
            k: 0,
            newClass:false,
        },
        data() {
            return {
                value: "",
                checkbox:[],
            }
        },
        methods: {
            isCheckbox() {
                return this.question.type === 'checkbox' || this.question.type === 'radio' || this.question.type === 'select';
            },
            onChange(k,$event){

                this.checkbox[k] = $event.target.checked ? this.question.content[k].value : "";

                console.log(this.checkbox);
                tools.$emit("newResponse", this.k, {
                    question: this.question.id,
                    value: this.checkbox
                })
            },
            isChecked(k){
                return this.checkbox[k];
            }
        },
        computed:{
            questionLabel(){
                return tools.nl2br(this.question.label)
            },
            questionText(){
                if(!this.question.text){
                    return ""
                }
                return tools.nl2br(this.question.text)
            }
        },
        watch: {
            value() {
                let value = this.value;
                if(!Array.isArray(value)){
                    value = [value]
                }

                tools.$emit("newResponse", this.k, {
                    question: this.question.id,
                    value: [this.value]
                })
                console.log(value)
            },
            // response(){
            //     console.log("update response");
            //     this.value = this.response.value[0]
            // }
        },
        mounted() {
            console.log(this.question)
            console.log(this.response)
            if(this.response && this.response.value && this.response.value.length > 0){
                this.value = this.response.value[0]
            }
            if(this.question.content.length > 1 && this.question.type === "checkbox"){
                this.question.content.forEach((content) => {
                    this.checkbox.push("")
                })
            }
        }
    }
</script>

<style>

</style>
